import React, { useCallback } from "react";
import { useIntl } from "react-intl";
import { Upload } from "antd";

import CustomIcon from "../customIcon";
import colors from "../../../../colors";
import TooltipButton from "../tooltipButton";
import { success, error } from "../../../../modules/messages";

const { Dragger } = Upload;

function UploadFile({
  accept,
  buttonText,
  onlyButton,
  buttonTitle,
  showSuccess = true,
  requestMethod,
  fileRestriction,
}) {
  const intl = useIntl();
  const handleChange = useCallback(
    (info) => {
      const { status, response } = info.file;
      if (status === "done") {
        if (response.success) {
          showSuccess &&
            success(
              intl.formatMessage(
                {
                  id: "import.uploadSuccess",
                  defaultMessage: "Soubor {name} byl úspěšně nahrán.",
                },
                { name: info.file.name }
              ),
              10
            );
        } else {
          error(
            intl.formatMessage(
              {
                id: "import.uploadError",
                defaultMessage:
                  "Při zpracování souboru nastala chyba: {message}",
              },
              { message: response.message }
            ),
            10
          );
          /* error(
            intl.formatMessage({
              id: "import.uploadErrorInfo",
              defaultMessage:
                "Zkontrolujte, zda používáte nejnovější šablonu, mohlo dojít k přidání nových atributů.",
            }),
            10
          ); */
        }
      } else if (status === "error") {
        error(
          intl.formatMessage(
            {
              id: "import.uploadFailure",
              defaultMessage: "Nahrávání souboru {name} selhalo.",
            },
            { name: info.file.name }
          ),
          10
        );
      }
    },
    [intl, showSuccess]
  );

  return onlyButton ? (
    <Upload
      showUploadList={false}
      onChange={handleChange}
      customRequest={requestMethod}
      accept={accept || "application/JSON"}
    >
      <TooltipButton icon="import" text={buttonText} title={buttonTitle} />
    </Upload>
  ) : (
    <Dragger
      accept={accept}
      onChange={handleChange}
      showUploadList={{
        showRemoveIcon: true,
        showPreviewIcon: false,
        showDownloadIcon: false,
      }}
      customRequest={requestMethod}
    >
      <p className="ant-upload-drag-icon">
        <CustomIcon type="inbox" color={colors.RED} />
      </p>
      <p className="ant-upload-text">
        {intl.formatMessage({
          id: "import.clickOrDrag",
          defaultMessage: "Zde klikněte nebo přetáhněte soubor",
        })}
      </p>
      <p className="ant-upload-hint">{fileRestriction}</p>
    </Dragger>
  );
}

export default UploadFile;
